import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillSparkle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
    <g clipPath="url(#clip0_3448_14573)">
      <path
        d="M16.6344 5.66462C17.3431 4.09559 19.5712 4.09559 20.2799 5.66463L23.8887 13.655C24.0891 14.0987 24.4445 14.4541 24.8882 14.6545L32.8786 18.2633C34.4476 18.972 34.4476 21.2001 32.8786 21.9088L24.8882 25.5176C24.4445 25.718 24.0891 26.0734 23.8887 26.5171L20.2799 34.5075C19.5712 36.0765 17.3431 36.0765 16.6344 34.5075L13.0256 26.5171C12.8252 26.0734 12.4698 25.718 12.0261 25.5176L4.03572 21.9088C2.46668 21.2001 2.46669 18.972 4.03572 18.2633L12.0261 14.6545C12.4698 14.4541 12.8252 14.0987 13.0256 13.655L16.6344 5.66462Z"
        fill="currentColor"
      />
      <path
        d="M5.5625 35.125C7.53001 35.125 9.125 33.53 9.125 31.5625C9.125 29.595 7.53001 28 5.5625 28C3.59499 28 2 29.595 2 31.5625C2 33.53 3.59499 35.125 5.5625 35.125Z"
        fill="currentColor"
      />
      <path
        d="M30.5744 2.01786C30.9287 1.23334 32.0428 1.23334 32.3971 2.01786L33.357 4.14325C33.4572 4.36511 33.6349 4.5428 33.8568 4.643L35.9821 5.60293C36.7667 5.95725 36.7667 7.07132 35.9821 7.42565L33.8568 8.38557C33.6349 8.48577 33.4572 8.66346 33.357 8.88532L32.3971 11.0107C32.0428 11.7952 30.9287 11.7952 30.5744 11.0107L29.6144 8.88532C29.5142 8.66346 29.3365 8.48577 29.1147 8.38557L26.9893 7.42565C26.2048 7.07132 26.2048 5.95725 26.9893 5.60293L29.1147 4.643C29.3365 4.5428 29.5142 4.36511 29.6144 4.14325L30.5744 2.01786Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3448_14573">
        <rect width="38" height="38" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default withDefaultStyles(FillSparkle)
